import { ReactElement } from "react";

import { notFoundCss, headerCss } from "./NotFound.style";

interface NotFoundProps {
  title?: string;
  subTitle: string;
}

const NotFound = ({
  title = "No results found",
  subTitle,
}: NotFoundProps): ReactElement => {
  return (
    <div css={notFoundCss}>
      <h2 css={headerCss}>{title}</h2>
      <span>{subTitle}</span>
    </div>
  );
};

export default NotFound;
